/* eslint-disable-next-line */
import Swiper from 'swiper/bundle'; // NOSONAR
import SwiperExt from '../swiper';

const { feWp } = window;
const { addFilter } = feWp.hooks;

addFilter( 'b3rg_slider_library', 'b3rg/slider', () => {
  return SwiperExt;
} );